<template>
    <div class="row g-3 mb-4">
        <!-- NAGŁÓWEK W SPÓJNYM STYLU Z PRZEWIJANIEM -->
        <div ref="headerRef" class="col-12 d-flex justify-content-between align-items-center border-bottom pb-2 cursor-pointer" @click="toggleSection">
            <h6 class="fw-bold mb-0">5. Nabywca</h6>
            <button type="button" class="btn btn-sm btn-link text-decoration-none p-0">
                <i class="bi" :class="sectionCollapse ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
            </button>
        </div>

        <!-- TREŚĆ SEKCJI -->
        <div class="col-12" v-show="sectionCollapse">
            <PartyFormFields 
                v-model="party" 
                :countries="dicts?.countries" 
                :show-gus="true" 
                :loading-gus="loadingGus"
                @fetchGus="fetchGusData" 
            />
        </div>
    </div>
</template>

<script setup>
import { ref, computed, nextTick } from 'vue'
import apiClient from '@/api'
import { webAlert } from '@/utils/dialog'
import PartyFormFields from './PartyFormFields.vue'

const props = defineProps({
    modelValue: { type: Object, required: true },
    dicts: { type: Object, default: () => ({ countries: [] }) }
})

const emit = defineEmits(['update:modelValue'])

const headerRef = ref(null)
const sectionCollapse = ref(false)
const loadingGus = ref(false)

const party = computed({
    get: () => props.modelValue,
    set: (val) => emit('update:modelValue', val)
})

const toggleSection = async () => {
    sectionCollapse.value = !sectionCollapse.value
    if (sectionCollapse.value) {
        await nextTick()
        headerRef.value?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
}

// Pobieranie i mapowanie danych z GUS dla Nabywcy
const fetchGusData = async () => {
    const cleanNip = (party.value.nip || '').replace(/[\s-]/g, '')

    if (!/^\d{10}$/.test(cleanNip)) {
        webAlert('Niepoprawny polski numer NIP')
        return
    }

    loadingGus.value = true
    try {
        const response = await apiClient.post(
            {
                action: 'get_data_from_gus',
                nip: cleanNip
            }
        )

        const resData = response.data

        if (resData?.type === 'success' && resData?.data) {
            const gus = resData.data

            // Mapowanie zwróconych pól GUS na pola obiektu formularza
            Object.assign(party.value, {
                companyName: gus.name || party.value.companyName,
                street: gus.address || party.value.street,
                postalCode: gus.zipcode || party.value.postalCode,
                city: gus.city || party.value.city,
                country: gus.country ? (gus.country === 'POLSKA' ? 'Polska' : gus.country) : party.value.country
            })

        } else if (resData?.message) {
            webAlert(resData)
        } else {
            webAlert('Nie znaleziono firmy o podanym numerze NIP.')
        }
    } catch (error) {
        console.error('Błąd podczas pobierania danych z GUS:', error)
        webAlert('Wystąpił błąd podczas połączenia z API GUS.')
    } finally {
        loadingGus.value = false
    }
}
</script>

<style scoped>
.cursor-pointer { cursor: pointer; user-select: none; }
</style>